import {NumberParam, StringParam, useQueryParam} from 'use-query-params';
import {
    NextProblemEntryEnum,
    NextProblemRequestArgument,
} from '@types';
import {useMemo} from 'react';
import {useLocation} from 'react-router';
import qs from 'qs';
import {parseFiltersDto, parseOrders} from '@utils/problemFilterQuery';

export const useProblemFilterQueryParams = (params?: {
    lastProblemId?: number;
    filterCursorElo?: number;
}): NextProblemRequestArgument => {
    const [name] = useQueryParam('name', StringParam);
    const [offset] = useQueryParam('offset', NumberParam);
    const [collectionId] = useQueryParam('collectionId', NumberParam);
    const [rating] = useQueryParam('rating', NumberParam);
    const [levelFrom] = useQueryParam('levelFrom', NumberParam);
    const [levelTo] = useQueryParam('levelTo', NumberParam);
    const [madeByUser] = useQueryParam('madeByUser', StringParam);
    const [filterCursorElo] = useQueryParam('filterCursorElo', NumberParam);
    const {search} = useLocation();

    const parsedQuery = useMemo(
        () => qs.parse(search, {ignoreQueryPrefix: true}),
        [search]
    );

    const filtersDto = useMemo(
        () => parseFiltersDto(parsedQuery.filtersDto),
        [parsedQuery]
    );

    const orders = useMemo(
        () => parseOrders(parsedQuery.orders),
        [parsedQuery]
    );

    return {
        name: name as NextProblemEntryEnum | undefined,
        offset,
        collectionId,
        rating,
        levelFrom,
        levelTo,
        madeByUser,
        filterCursorElo: filterCursorElo ?? params?.filterCursorElo,
        filtersDto,
        lastProblemId: params?.lastProblemId, // not from query
        orders,
    };
};
